


















import { AxiosError, AxiosResponse } from 'axios';
import _ from 'lodash';
import { Component, Watch, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import { CONFIG } from '@/config';
import { NOTIFICATIONS_GET, NOTIFICATIONS_HIDE, NOTIFICATIONS_UPDATE } from '@/store/modules/notifications/types';
import { httpService, i18nService, notificationService } from '@/services';
import { INotificationMessage } from '@/interfaces';

@Component
export default class Toast extends Vue {
  @Getter(NOTIFICATIONS_GET)
  public notification: INotificationMessage;

  @Action(NOTIFICATIONS_HIDE)
  public hideNotification: Function;

  @Action(NOTIFICATIONS_UPDATE)
  public updateNotifications: Function;

  private timeout: any;

  @Watch('notification')
  updateNotification(notification: INotificationMessage) {
    if (!notification.message) {
      return;
    }

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => {
      this.hideNotification();
      clearTimeout(this.timeout);
      this.timeout = undefined;
    }, this.notification.timeout);
  }

  mounted() {
   // this.requestData();
  }

  private requestData() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/notification`)
      .then((res: AxiosResponse) => {
        this.updateNotifications(
          _.map(res.data, (d: any) => ({
            id: d.id,
            createdAt: d.createdAt,
            type: notificationService.getNotificationColor(d.notificationType),
            icon: notificationService.getNotificationIcon(d.notificationType),
            title: i18nService.i18n(`Upload.${_.capitalize(notificationService.getNotificationContext(d.notificationContext))}`),
            message: d.message
          }))
        );
      })
      .catch((err: AxiosError) => console.log(err.message));
  }
}
